import Colors from 'assets/Colors';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { SafeAreaInsetsContext } from 'react-native-safe-area-context';

export default class SafeView extends React.PureComponent {
  static insets = { top: 0, bottom: 0, left: 0, right: 0 };

  static getPaddingBottom() {
    return SafeView.insets.bottom;
  }

  static getPaddingTop() {
    return SafeView.insets.top;
  }

  render() {
    return (
      <SafeAreaInsetsContext.Consumer>
        {(insets) => {
          SafeView.insets = insets || SafeView.insets;
          const style = StyleSheet.flatten([
            {
              flex: 1,
              minHeight: '100vh',
              paddingTop: insets ? insets.top : 0,
              paddingBottom: insets ? insets.bottom : 0,
              backgroundColor: Colors.primary
            },
            this.props.style
          ]);

          return <View style={style}>{this.props.children}</View>;
        }}
      </SafeAreaInsetsContext.Consumer>
    );
  }
}
